import { usePermissions } from '@refinedev/core'

import { hasPermission } from '@/auth/capabilities'
import { USER_ROLES } from '@/constants/roles'
import { useRoles } from '@/pages/roles/hooks/useRoles'

import { useUserActions } from '../hooks/useUserActions'
import { SetPropertyModal } from './SetPropertyModal'

interface Props {
  open: boolean
  userIds: string[]
  userEmail?: string
  currentRole?: string
  onClose: () => void
}

export function SetRoleModal({
  open,
  userIds,
  userEmail,
  currentRole,
  onClose,
}: Props) {
  const { setRole } = useUserActions()
  const { data: permissions = [] } = usePermissions<string[]>({})
  const canReadRoles = hasPermission(permissions, 'admin:roles:read')
  const { roles, isLoading, error } = useRoles(canReadRoles)
  const roleNames = canReadRoles
    ? roles.map((role) => role.name)
    : [...USER_ROLES]

  const options = roleNames.map((role) => ({ label: role, value: role }))
  // Keep the user's current role selectable even if it's missing from the list.
  if (currentRole && !roleNames.includes(currentRole)) {
    options.unshift({ label: currentRole, value: currentRole })
  }

  return (
    <SetPropertyModal
      open={open}
      title="Set Role"
      label="Role"
      fieldName="roleName"
      userIds={userIds}
      userEmail={userEmail}
      currentValue={currentRole}
      options={options}
      optionsLoading={canReadRoles && isLoading}
      optionsError={
        canReadRoles && error
          ? 'Failed to load roles. Close and try again.'
          : undefined
      }
      onSubmit={(value, ids) => setRole(value, ids)}
      onClose={onClose}
    />
  )
}
